var _desc, _linearGradient, _path, _radialGradient, _path2, _radialGradient2, _path3, _radialGradient3, _path4, _path5, _radialGradient4, _path6, _radialGradient5, _path7, _path8, _path9, _path10, _path11, _radialGradient6, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNissan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2141,
    viewBox: "5 4.87 200 171.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nissan Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "F\xFCr mehr Informationen siehe: http://de.wikipedia.org/wiki/Datei:Nissan_Logo.svg")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -1926.795,
    y1: 1110.028,
    x2: -1926.795,
    y2: 1249.429,
    gradientTransform: "translate(2031.795 -1102.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.119 69.765c-1.848-.516-3.906-.76-8.241-1.295-17.942-.736-62.282-2.46-84.877-2.46-22.594 0-66.935 1.723-84.875 2.46-4.337.535-6.397.779-8.244 1.295C6.241 71.095 5 73.12 5 77.16v27.689c0 4.041 4.329 6.764 7.313 7.313 2.986.553 4.875.774 8.016 1.073 16.047.994 53.277 3.066 84.671 3.099 31.395-.03 68.623-2.104 84.671-3.099 3.14-.299 5.03-.521 8.017-1.073 2.983-.55 7.312-3.272 7.312-7.313V77.16c0-4.04-1.24-6.065-6.881-7.395z",
    fill: "url(#a)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -1982.938,
    cy: 1073.071,
    r: 139.463,
    gradientTransform: "translate(2031.795 -1102.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.05 70.854c8.828-30.71 37.835-53.243 72.268-53.243 34.334 0 63.282 22.409 72.196 52.996.028.108.047.164.078.268 5.118-.575 9.703-1.463 12.943-2.328-.059-.197-.074-.237-.125-.431C180.279 31.681 146.021 4.87 105.318 4.87c-40.84 0-75.188 26.985-85.194 63.6 4.501 1.233 7.798 1.75 12.926 2.384z",
    fill: "url(#b)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -1645.429,
    cy: 1296.455,
    r: 290.45,
    gradientTransform: "translate(2031.795 -1102.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.303 111.104c-.089.273-.188.574-.234.723-9.387 29.852-37.957 51.564-71.75 51.564-34.06 0-62.81-22.047-71.969-52.258-5.598.991-7.489 1.368-13.021 2.104 10.25 36.257 44.414 62.895 84.99 62.895 40.593 0 74.769-26.666 85-62.953-4.874-.602-7.745-1.057-13.016-2.075z",
    fill: "url(#c)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -1949.44,
    cy: 1232.36,
    r: 89.169,
    gradientTransform: "translate(2031.795 -1102.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.852 70.788c2.125-.878 4.181-2.278 7.386-3.179 9.555-24.825 34.189-42.503 63.079-42.503 28.8 0 53.373 17.569 62.988 42.274.034.084.069.186.096.249 1.654.573 6.527 2.549 8.043 3.21.215.005.674.021 1.148.034a7.05 7.05 0 0 1-.078-.268c-8.918-30.577-37.865-52.979-72.197-52.979-34.424 0-63.431 22.523-72.262 53.227.51.001 1.481-.043 1.797-.065z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.769 19.703c32.213 0 60.768 19.208 71.584 50.869l.088.269c.168 0 .781.022 1.148.034-.029-.115-.059-.182-.078-.268-8.918-30.577-37.865-52.979-72.197-52.979-34.424 0-63.431 22.523-72.262 53.227.688-.011 1.019-.011 1.799-.066 9.67-30.058 37.942-51.086 69.918-51.086z",
    fill: "#fff"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -1877.483,
    cy: 1323.538,
    r: 169.194,
    gradientTransform: "translate(2031.795 -1102.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.477 111.191c-2.314 1.293-5.195 2.537-7.498 3.264-.031.074-.162.402-.19.479-9.962 24.022-34.179 40.979-62.471 40.979-28.47 0-52.811-17.163-62.657-41.423-2.649-.735-6.609-2.541-8.108-3.295-.561-.027-.863-.043-1.208-.061 9.159 30.207 37.914 52.258 71.974 52.258 33.906 0 62.55-21.849 71.843-51.843.02-.058.123-.388.145-.444-.537.021-1.358.086-1.83.086z",
    fill: "url(#e)"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -1928.135,
    cy: 1125.143,
    r: 134.452,
    gradientTransform: "translate(2031.795 -1102.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.516 71.77c-4.752-.578-7.992-.516-19.568-.915-.526-.019-1.061-.035-1.604-.054-20.99-.72-52.52-1.682-70.344-1.682-17.823 0-49.352.962-70.345 1.682-.542.019-1.075.035-1.6.054-11.578.399-14.817.337-19.57.915C8.733 72.353 5 74.434 5 77.973v25.677c0 3.541 4.497 6.408 8.484 6.408 0 0 50.746 3.133 91.516 3.17 40.771-.037 91.516-3.17 91.516-3.17 3.987 0 8.484-2.867 8.484-6.408V77.973c0-3.539-3.732-5.62-8.484-6.203z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.477 111.191c-9.959 29.543-37.967 50.123-69.604 50.123-31.959 0-60.317-18.906-71.323-50.123-.404-.021-.804-.037-1.199-.06 9.157 30.208 37.917 52.259 71.978 52.259 34.072 0 62.835-22.065 71.984-52.289-.602.028-1.213.061-1.836.09z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.535 111.189l-.061.002c-2.314 1.293-5.193 2.537-7.498 3.264-.031.074-.162.402-.189.479-3.152 7.602-7.732 14.496-13.422 20.371 8.906-6.511 16.17-14.737 21.17-24.116z",
    fill: "#8c8c8c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.19 137.216c-6.698-6.38-12.03-14.103-15.53-22.728-2.649-.736-6.608-2.543-8.108-3.297a63.415 63.415 0 0 0 5.648 9.494c4.409 5.742 9.753 10.86 15.836 15.191.708.464 1.426.91 2.154 1.34z",
    fill: "#4d4d4d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.348 111.135v-.002l-.023.004c-5.58.989-7.473 1.368-12.997 2.1.445 1.58.938 3.137 1.475 4.678l11.545-6.78z",
    fill: "#252525"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: -1925.021,
    cy: 1138.607,
    r: 90.561,
    gradientTransform: "translate(2031.795 -1102.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.637 83.142c-1.668-3.728-1.076-3.337-4.707-3.433-.295-.1-1.082-.1-2.16-.1-1.076 0-1.274 0-2.158.1-3.432 0-2.844-.196-4.02 2.256 0 0-5.891 13.242-8.439 18.735l-.098.196c-.49.979-.195.979.588.979h5.299c.394 0 .588-.192.686-.392 0 0 .785-1.668 1.766-4.021h12.949c.982 2.257 1.668 3.923 1.668 4.021.098.295.393.392.686.392h5.494c.785 0 .982.103.688-.588-.983-2.353-7.359-16.088-8.242-18.145zm-11.283 9.612c1.668-3.923 3.338-7.748 3.338-7.847.099-.197.295-.295.588-.295.099-.1.395-.1.688-.1.197 0 .489 0 .588.1.195 0 .395.098.489.393.396 1.077 1.864 4.414 3.237 7.749h-8.928zM63.722 79.413c.49 0 .589.195.589.588v20.995c0 .488-.099.688-.686.688h-5.102c-.587 0-.685-.1-.685-.688V80.001c0-.393.098-.588.489-.588h5.395zm-10.889.195c.587 0 .688.195.688.688v20.896c0 .59-.101.688-.688.688h-5.985c-3.53 0-3.825 0-5.001-1.96-2.453-3.825-9.812-15.107-9.812-15.107v16.381c0 .591-.098.687-.685.687h-4.416c-.588 0-.687-.096-.687-.687V80.296c0-.491.099-.688.687-.688h5.101c3.826 0 4.316-.097 5.692 1.865 1.078 1.767 10.005 15.5 10.005 15.5V80.296c0-.491.098-.688.688-.688h4.413zm130.964 0c.592 0 .688.195.688.688v20.896c0 .59-.098.688-.688.688h-5.979c-3.535 0-3.83 0-5.006-1.96C170.357 96.092 163 84.811 163 84.811v16.382c0 .59-.098.686-.688.686H157.9c-.588 0-.689-.096-.689-.686V80.296c0-.491.102-.688.689-.688h5.1c3.826 0 4.318-.097 5.689 1.865 1.178 1.767 10.008 15.5 10.008 15.5V80.296c0-.491.099-.688.688-.688h4.412zm-97.609 8.538c3.925.391 6.771 1.077 7.555 4.806 0 .292.099 1.274.099 2.354 0 .688 0 1.568-.197 2.354-.685 3.531-3.336 4.217-7.454 4.217H69.707c-.589 0-.688-.096-.688-.686V97.66c0-.59.099-.688.688-.688h16.675c.688 0 .884-.195.981-.688v-.883-.588c-.099-.394-.196-.982-1.078-1.078-1.865-.098-7.357-.59-11.087-.981-4.807-.491-5.983-2.549-6.18-4.316-.098-.59-.098-1.374-.098-2.061 0-.589 0-1.471.098-2.159.688-3.141 3.043-4.61 7.161-4.61h15.99c.591 0 .788.1.788.589v3.631c0 .487-.197.685-.788.587H76.474c-.687 0-.98.294-1.08.98v.883c0 .491.295.884.981.979 1.868.2 7.654.69 9.813.889zm28.349 0c3.928.391 6.771 1.077 7.557 4.806 0 .292.098 1.274.098 2.354 0 .688 0 1.568-.196 2.354-.685 3.531-3.333 4.217-7.455 4.217H98.058c-.589 0-.688-.096-.688-.686V97.66c0-.59.099-.688.688-.688h16.678c.686 0 .879-.195.98-.688v-.883-.588c-.102-.394-.296-.982-1.08-1.078-1.863-.098-7.357-.59-11.084-.981-4.809-.491-5.886-2.549-6.182-4.316-.098-.59-.098-1.374-.098-2.061 0-.589 0-1.471.098-2.159.688-3.141 3.042-4.61 7.161-4.61h15.993c.586 0 .785.1.785.589v3.631c0 .487-.199.685-.785.587h-15.698c-.686 0-.979.294-1.079.98v.883c0 .491.197.884.983.979 1.864.2 7.65.69 9.807.889z",
    fill: "url(#g)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNissan);
export default __webpack_public_path__ + "static/media/nissan.61dda663efded14817566879941d72bf.svg";
export { ForwardRef as ReactComponent };